export default {
  title: 'Скачайте мобильное приложение жителя «Всегда рядом»',
  annotation: 'Установите приложение — используйте сервисы по управлению домом',
  welcomePlate: {
    leftTitle: 'Всегда рядом — сервисная компания от ГК «Ак Барс Дом»',
    rightTitle: 'Добро пожаловать, дорогой житель. ',
    textFirstParagraph: 'Здесь ты сможешь найти информацию о деятельности управляющих компаний, задать интересующие тебя вопросы о жизни твоего жилого комплекса и полезно провести время.',
    textSecondParagraph: 'В зону обслуживания управляющей компании входят следующие жилые комплексы: "Нобелевский", "Мой Ритм", "Солнечный город Супер", "Солнечный город", "Тулпар", "Казань ХХI век", "Светлая долина".',
    textThirdParagraph: 'Высокопрофессиональная команда — залог нашей успешной работы. Каждый день мы на страже вашей комфортной и счастливой жизни.',
    textFourthParagraph: 'Мы всегда рядом.',
    link: 'abd-vsegdaryadom.ru'
  },
  banner: {
    titleStart: 'Возникли вопросы? \n',
    titleEnd: 'Поможем'
  }
}
